import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { CurrentUserResponse } from '@api-swagger-client/index';

export const UserActions = createActionGroup({
    source: 'User',
    events: {
      'Get Current User': emptyProps(),
      'Set Current User': props<{ user: CurrentUserResponse }>()
    }
  });
